import React from 'react'

const Dashboard = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
    <h2 className="text-2xl font-semibold text-gray-800 mb-4">Dashboard</h2>
    <p className="text-gray-600">Dashboard content will be implemented here.</p>
  </div>
  )
}

export default Dashboard
